module.exports = __webpack_public_path__ + "static/media/linkCard_evs.b022d1a5.svg";